export default __webpack_public_path__ + "static/media/phone-call.0236e069.svg";